export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Badge.vue?vue&type=template&id=bb5780d8"


//////////////////
// WEBPACK FOOTER
// ./src/components/Badge.vue?vue&type=template&id=bb5780d8
// module id = 1414
// module chunks = 31